// noinspection ES6CheckImport

import React, {useEffect, useState} from "react";

// We use Route in order to define the different routes of our application
import {Route, Routes, Router, BrowserRouter, redirect, useNavigate, Navigate} from "react-router-dom";
import {db} from "./firebase/firebaseConfig2";
import {collection, getDocs} from "firebase/firestore"
// We import all the components we need in our app
import Navbar from "./components/navbar";
import Home from "./pages/Home"
import Footer from "./components/Footer";
import Reg from "./components/Reg";
import Upload from "./components/Upload";
import Program from "./pages/Program";
import About from "./pages/About";
import LiabRel from "./pages/LiabRel";
import Payment from "./pages/Payment";
import Redirect from "./pages/Redirect";

import "./App.css"
import Confirm from "./pages/Confirm";
import Deadlines from "./pages/Deadlines";

const App = () => {
    useEffect(() => {
        const timeout = setTimeout(() => {
            // 👇️ redirects to an external URL
            window.location.replace('https://www.pqeconference.com/');
        }, 3000);

        return () => clearTimeout(timeout);
    }, []);




    return (
            <div>
                <BrowserRouter basename={"/"}>
                    <Routes>

                        <Route exact path="/" element={<Redirect />} />

                        <Route path="/create" element={<Reg />} />
                        <Route path="/upload" element={<Upload />} />
                        <Route path="/program" element={<Program />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/LiabRel" element={<LiabRel />} />
                        <Route path="/pay" element={<Payment />} />
                        <Route path="/confirm" element={<Confirm />} />
                        <Route path={"/deadlines"} element={<Deadlines />} />


                    </Routes>

                </BrowserRouter>


            </div>


    );
};

export default App;
